import React from 'react';
import { Table } from '@tinper/next-ui';

const ColumnGroup = Table.Column;

class EditTableColumnGroup extends React.Component {
//   constructor (props) {
//     super(props);
//   }

  render () {
    // let {} = this.props;
    return (
      <ColumnGroup {...this.props}/>
    )
  }
}
EditTableColumnGroup.TagName = 'EditTableColumnGroup'
export default EditTableColumnGroup;
